import type { SalesminerAccount } from '@/types/serializers'
import AccountLayout from './_layout/AccountLayout.tsx'
import OverviewTab from './_tabs/OverviewTab.tsx'

interface ValueDiscoveryFrameworkType {
    id: number
    product_name: string
    product_components: string
    kpis: string
    kpi_drivers: string
}


interface Props {
    account: SalesminerAccount
    valueDiscoveryFrameworks: ValueDiscoveryFrameworkType[]
}

export default function AccountShow({account}: Props) {
    return (
        <AccountLayout account={account} activeTab="overview">
            <OverviewTab account={account}/>
        </AccountLayout>
    )
}